module.exports = __webpack_public_path__ + "static/VS_icon01-01-73386cf562b2882e0a56a3f046696460.png";